import DesignConstants from "../../../constants/DesignConstants";
import styled from "styled-components";

// Sticky bar under the app header holding the close (x) button; shared by the
// test & practice and vocab-training creation headers.
export const StickyCloseButtonWrapper = styled.div`
    position: sticky;
    z-index: 3;
    top: 60px;
    background: ${DesignConstants.COLORS.BACKGROUND_LIGHT};
    margin: -1rem auto 0;
    padding: ${DesignConstants.SPACES.S} 0 ${DesignConstants.SPACES.XS};
    width: 101%;
`;
